import {
  VariableCollectionMap,
  type VariableMap,
  renderCssVariableName,
} from '@packages/systems/core/utils/StyleVariables';
import {Plugins} from '@packages/systems/wfdl';

export type VariableEntries = {
  [id: string]: string; // name;
};

export function getVariableEntries(
  variables: VariableMap,
  variableCollections: VariableCollectionMap,
  slugMap: Plugins.PluginsType['slugMap']
): VariableEntries {
  if (!variables) {
    return {};
  }
  return variables.reduce<Record<string, any>>((result, variable) => {
    const renderedName = renderCssVariableName(
      variables,
      variableCollections,
      slugMap,
      variable.id
    );
    result[variable.id as string] = `--${renderedName}`;
    return result;
  }, {});
}
